import { useQuery } from '@tanstack/react-query';

import { matchupKeys } from '@/hooks/matchup/matchupKeys';
import { getMatchupSettings } from '@/infrastructure/network/data/matchups/matchup';

export const useMatchupSettingsQuery = (matchupId: string) => {
	return useQuery({
		queryKey: matchupKeys.matchupSettings(matchupId),
		queryFn: () => getMatchupSettings({ matchupUuid: matchupId }),
		enabled: !!matchupId
	});
};
